import api from "./api"
import store from "../store/index"

export async function getPayMethods() {
  const result = await api.get("/api/v1/checkout/paymethods", {
    params: {
      customerID: store.state.customerID ?? null,
    },
  })
  return result.data
}

export async function getFields() {
  const result = await api.get("/api/v1/checkout/fields", {
    params: {
      customerID: store.state.customerID ?? null,
    },
  })
  return result.data
}

export async function getTransportMethods({ countryID = "NL" } = {}) {
  const result = await api.get("/api/v1/checkout/transport", {
    params: {
      customerID: store.state.customerID ?? null,
      countryID,
    },
  })
  return result.data
}
